/**
 * API client for ddx_ditributor backend
 * Base URL: REACT_APP_BACKEND_URL (default http://localhost:8001)
 * All admin routes: /api/admin/*
 */

import axios from 'axios';

const BASE_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';
export const API_URL = `${BASE_URL}/api/admin`;

// Attach auth token to every request
axios.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
